import { Button, Checkbox, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { useLessonForm } from "./LessonFormContext";

const FormActions: React.FC = () => {
  const { handleSubmit, diagnosticLesson, setDiagnosticLesson } =
    useLessonForm();
  const navigate = useNavigate();

  return (
    <div className="form-actions">
      <Tooltip title="Marca la lección como diagnóstico: permite guardarla con una sola actividad (sin exigir Inicio, Desarrollo y Cierre) y en la plataforma se muestra con la etiqueta Diagnóstico.">
        <Checkbox
          checked={diagnosticLesson}
          onChange={(e) => setDiagnosticLesson(e.target.checked)}
        >
          Lección diagnóstico
        </Checkbox>
      </Tooltip>
      <Button type="default" onClick={() => navigate(-1)}>
        Cancelar
      </Button>
      <Button
        type="primary"
        onClick={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        Guardar
      </Button>
    </div>
  );
};

export default FormActions;
